import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ChevronLeft from "../icons/chevron-leftG.svg";

const Breadcrumbs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const breadcrumbMap = {
    "/clients": t("titles.sb_clients"),
    "/clients/details": t("titles.client_details"),
    "/clients/add": t("form_titles.add_clients"),
    "/clients/modify": t("form_titles.edit_clients"),
    "/clients/details/modify": t("form_titles.edit_clients"),
    "/orders": t("titles.orders"),
    "/orders/add": t("form_titles.add_orders"),
    "/orders/modify": t("form_titles.edit_orders"),
    "/orders/details": t("titles.order_details"),
    "/orders/details/modify": t("form_titles.edit_orders"),
    "/delivery-notes": t("titles.bl"),
    "/delivery-notes/details": t("titles.delivery_note_details"),
    "/credit-notes": t("titles.br"),
    "/credit-notes/add": t("form_titles.add_creditNotes"),
    "/credit-notes/details": t("titles.br_details"),
    "/invoices": t("titles.invoices"),
    "/invoices/details": t("titles.invoice_details"),
    "/invoices/modify": t("form_titles.edit_invoices"),
    "/purchases": t("titles.purchases"),
    "/purchases/add": t("form_titles.add_purchases"),
    "/transfer-requests": t("titles.requests"),
    "/transfer-requests/add": t("form_titles.add_requests"),
    "/transfer-requests/modify": t("form_titles.edit_requests"),
    "/payments": t("titles.payments"),
    "/payments/modify": t("form_titles.add_payments"),
    "/payments/details": t("titles.payment_details"),
    "/payments/details/modify": t("form_titles.edit_payments"),
    "/quotes": t("titles.quotes"),
    "/quotes/add": t("form_titles.add_quotes"),
    "/quotes/modify": t("form_titles.edit_quotes"),
    "/quotes/details": t("titles.quote_details"),
    "/quotes/details/modify": t("form_titles.edit_quotes"),
    "/avoirs-financiers": t("titles.afinancier"),
    "/avoirs-financiers/add": t("form_titles.add_afinancier"),
    "/avoirs-financiers/details": t("titles.afinancier"),
    "/avoirs-financiers/modify": t("form_titles.edit_afinancier"),
    "/avoirs-financiers/details/modify": t("form_titles.edit_afinancier"),
    "/avoirs-fournisseurs": t("titles.afournisseur"),
    "/avoirs-fournisseurs/add": t("form_titles.add_afournisseur"),
    "/avoirs-fournisseurs/details": t("titles.afournisseur"),
    "/avoirs-fournisseurs/modify": t("form_titles.edit_afournisseur"),
    "/expenses": t("titles.expenses"),
    "/expenses/add": t("form_titles.add_expenses"),
    "/expenses/details": t("titles.expense_details"),
    "/expenses/details/modify": t("form_titles.edit_expenses"),
    "/expenses/modify": t("form_titles.edit_expenses"),
  };

  const pathnames = location.pathname.split("/").filter((x) => x);
  let currentPath = "";
  let dynamicId = null;
  let breadcrumbPaths = [];

  for (const segment of pathnames) {
    currentPath += `/${segment}`;
    if (!isNaN(segment)) {
      dynamicId = segment;
      continue;
    }
    if (breadcrumbMap[currentPath]) {
      breadcrumbPaths.push({ path: currentPath, label: breadcrumbMap[currentPath] });
    }
  }

  breadcrumbPaths = breadcrumbPaths.map((breadcrumb) => {
    if (breadcrumb.path.includes("details") && dynamicId) {
      return { path: `${breadcrumb.path}/${dynamicId}`, label: breadcrumb.label };
    }
    return breadcrumb;
  });

  breadcrumbPaths.pop(); 

  const { filters, page, size } = location.state || {};

  const handleBreadcrumbClick = (path) => {
    history.push({
      pathname: path,
      state: filters || page !== undefined || size !== undefined ? { filters, page, size } : undefined,
    });
  };

  return (
    <nav className="text-[#A8ADC3] text-[16px] font-semibold flex items-center">
      {breadcrumbPaths.length > 0 && (
        <>
          <img src={ChevronLeft} alt="Chevron" className="w-4 h-4" />
          {breadcrumbPaths.map(({ path, label }, index) => (
            <span key={path} className="flex items-center">
              <span onClick={() => handleBreadcrumbClick(path)} className="hover:underline cursor-pointer">
                {label}
              </span>
              {index < breadcrumbPaths.length - 1 && (
                <img src={ChevronLeft} alt="Chevron" className="w-4 h-4" />
              )}
            </span>
          ))}
        </>
      )}
    </nav>
  );
};

export default Breadcrumbs;